import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ProductCategoryService,
  ProductCategory,
  ProductCategoryUpdateInput,
} from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN } from 'src/app/shared/constants/operationals';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-product-category-update-category-dialog',
  templateUrl: './product-category-update-category-dialog.component.html',
  styleUrls: ['./product-category-update-category-dialog.component.scss'],
})
export class ProductCategoryUpdateCategoryDialogComponent {
  product_category_update_category_from_group: FormGroup =
    this.form_service.product_category_update_category_from_group;
  category?: ProductCategory;
  is_submit_running: boolean = false;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<ProductCategoryUpdateCategoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private product_category_service: ProductCategoryService,
    private form_service: FormService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {
    this.category = data.category;
  }
  ngOnInit(): void {
    this.product_category_update_category_from_group.reset();
    this.populateForm();
  }

  populateForm(): void {
    if (this.category) {
      this.product_category_update_category_from_group
        .get(this.form_service.product_category_name_label)
        ?.setValue(this.category.name);
      this.product_category_update_category_from_group
        .get(this.form_service.product_category_decido_evaluation_code_label)
        ?.setValue(this.category.decido_evaluation_code);
    }
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.product_category_update_category_from_group);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSubmitClick(): void {
    if (this.isFormValid()) {
      const name: string = this.product_category_update_category_from_group.get(
        this.form_service.product_category_name_label,
      )?.value;

      const decido_evaluation_code: string = this.product_category_update_category_from_group.get(
        this.form_service.product_category_decido_evaluation_code_label,
      )?.value;

      const params: ProductCategoryUpdateInput = {
        name: name || undefined,
        decido_evaluation_code: decido_evaluation_code || undefined,
      };

      this.updateProductCategory(params);
    }
  }

  updateProductCategory(product_category: ProductCategoryUpdateInput): void {
    this.is_submit_running = true;
    this.product_category_service
      .updateProductCategory(this.category?.product_category_id as string, product_category)
      .subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_submit_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_submit_running = false;
        },
      });
  }
}
